import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { LocateFixed, Minus, Plus } from "lucide-react";
import { t, useLanguage } from "@/i18n/LanguageContext";

export const ProjectMapControls = ({ groups }) => {
  const map = useMap();
  const { language } = useLanguage();
  const fit = () => map.fitBounds(groups.map((g) => g.position), { padding: [40, 40], maxZoom: 12, animate: false });
  useEffect(() => {
    if (groups.length) map.fitBounds(groups.map((g) => g.position), { padding: [40, 40], maxZoom: 12, animate: false });
  }, [map, groups]);
  useEffect(() => {
    const observer = new ResizeObserver(() => map.invalidateSize({ pan: false }));
    observer.observe(map.getContainer());
    map.getContainer().setAttribute("data-testid", "project-map-canvas");
    map.getContainer().setAttribute("aria-label", t("Mappa dei cantieri"));
    map.getContainer().querySelectorAll(".leaflet-control-attribution a").forEach((link) => link.setAttribute("data-testid", link.href.includes("openstreetmap.org") ? "map-attribution-osm" : "map-attribution-leaflet"));
    return () => observer.disconnect();
  }, [map, language]);
  return (
    <div className="absolute left-3 top-3 z-[800] flex flex-col gap-1" onDoubleClick={(e) => e.stopPropagation()}>
      {[["zoom-in", "Ingrandisci mappa", Plus, () => map.zoomIn()], ["zoom-out", "Riduci mappa", Minus, () => map.zoomOut()], ["reset", "Mostra tutti i comuni", LocateFixed, fit]].map(([id, label, Icon, action]) => (
        <button key={id} type="button" data-testid={`project-map-${id}`} title={t(label)} aria-label={t(label)} onClick={(event) => { event.stopPropagation(); action(); }} className="flex h-11 w-11 items-center justify-center rounded-md border border-slate-200 bg-white text-brand-navy shadow-sm transition-colors hover:bg-brand-limelight focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-navy">
          <Icon className="h-5 w-5" />
        </button>
      ))}
    </div>
  );
};